import request from '@/utils/request'
import APIS from '@/permissions/index'

export function queryProductTypes (params) {
  return request({
    ...APIS['@productManage/Query_ProductTypes'],
    params
  })
}

export function querySubsidyTypes (params) {
  return request({
    ...APIS['@productManage/Query_SubsidyTypes'],
    params
  })
}

export function queryProducts (params) {
  return request({
    ...APIS['@productManage/Query_Products'],
    params
  })
}

export function deleteProduct (params) {
  return request({
    ...APIS['@productManage/Delete_Product'],
    params
  })
}

export function deleteProductType (data) {
  return request({
    ...APIS['@productManage/Delete_ProductType'],
    data
  })
}

export function updateProductType (data) {
  return request({
    ...APIS['@productManage/Update_ProductType'],
    data
  })
}

export function addProductType (data) {
  return request({
    ...APIS['@productManage/Add_ProductType'],
    data
  })
}

export function updateProduct (data) {
  return request({
    ...APIS['@productManage/Update_Product'],
    data
  })
}
export function addProduct (data) {
  return request({
    ...APIS['@productManage/Add_Product'],
    data
  })
}

export function exportProductTypes (params) {
  const headers = {
    'Content-Type': 'application/octet-stream'
  }
  const responseType = 'arraybuffer'
  return request({
    ...APIS['@productManage/Export_ProductTypes'],
    params,
    headers,
    responseType
  })
}

export function exportProducts (params) {
  const headers = {
    'Content-Type': 'application/octet-stream'
  }
  const responseType = 'arraybuffer'
  return request({
    ...APIS['@productManage/Export_Products'],
    params,
    headers,
    responseType
  })
}

export function changeOrder (data) {
  return request({
    ...APIS['@productManage/Change_Order'],
    data
  })
}
